module.exports = __webpack_public_path__ + "media/promo/panasonic/images/recipes/rec-2-min-ab323ca9a93518dd57f0c130ced13ecc.jpg";